module.exports = __webpack_public_path__ + "static/media/home_icon.80423381.svg";